import { fetchResource } from "@src/app/utils";
import { auth } from "@src/app/utils/firebase";
import { z } from "zod";
import { trackSchema } from "./schemas";
import type { Track } from "./types";

export const getTrackSource = (id: string, platform: string) =>
	fetchResource(`track/${platform}/${id}/source`, z.object({ url: z.string().url() }), "GET", undefined, {
		apiVersion: "v2",
	});

/**
 * Get trending universe tracks
 */
export const getUniverseTrending = (page = 1) =>
	fetchResource(`track/universe/trendings?page=${page}`, z.array(trackSchema));

/**
 * update track data
 */
export const patchTrack = (id: string, track: FormData) =>
	fetchResource(`track/${id}`, trackSchema, "PATCH", track, {
		formData: true,
	});

/**
 * Create new TTS track
 */
export const postTTSTrack = (formData: FormData) =>
	fetchResource("track/tts", trackSchema, "POST", formData, {
		formData: true,
	});

/**
 * Create new track
 * @param formData **name**: `string`, **file**: `Blob`, **photo**: `Blob | undefined`, **private**: `"true" | "false"`, **type**: `TrackCreateType`
 */
export const postTrack = async (
	formData: FormData,
	onProgress: (loaded: number) => void,
	onSuccess: (track: Track) => void,
	onError: () => void,
) => {
	const token = await auth.currentUser?.getIdToken();
	const request = new XMLHttpRequest();
	request.upload.addEventListener("progress", (e) => {
		onProgress(e.loaded / e.total);
	});
	request.addEventListener("readystatechange", () => {
		if (request.readyState === 4) {
			let json: unknown;
			try {
				if (!request.status.toString().startsWith("2")) {
					onError();
					return;
				}
				json = JSON.parse(request.response);
			} catch (e) {
				onError();
				return;
			}
			try {
				onSuccess(trackSchema.parse(json));
			} catch {
				onError();
			}
		}
	});
	request.addEventListener("error", () => {
		onError();
	});
	request.open("post", `${import.meta.env.VITE_API_URI}/${import.meta.env.VITE_API_VERSION}/track`);
	request.setRequestHeader("Authorization", `Bearer ${token}`);
	request.send(formData);
};
